<input matInput type="file" #fileSelector [accept]="acceptedTypes" (change)="onFileSelectorChange()" class="cdk-visually-hidden" />
@if (!hidden) {
  <button mat-raised-button mat-ripple mat-button-ripple (click)="openFileSelectorDialog()" type="button">{{ buttonLabel }}</button>
}
